import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/cardinalReport'
import Component from 'components/Reports/CardinalReport'

export default createListViewContainer({ actions, selectors: selectors.cardinalReport })(Component)
